/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import styled from "styled-components";

import {PrimaryText} from "../Text";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

const appBannerIllustration = `${WealthyEnv.HOMEPAGE_CDN_URL}/banner-phone-illustration.png`;

const AppBanner = () => {
  const onBannerClick = () => {
    window.open(`${WealthyEnv.APP_DOWNLOAD_ONE_LINK}`);
  };

  return (
    <AppBannerContainer
      id="mob-download-app-banner"
      onClick={onBannerClick}
    >
      <AppBannerLogo
        alt="wealthy-Banner-Logo"
        loading="lazy"
        src={appBannerIllustration}
      />
      <AppBannerText>
        Track & Manage your wealth on the go
      </AppBannerText>
      <AppBannerButton>
        Install app
      </AppBannerButton>
    </AppBannerContainer>
  );
};

const AppBannerContainer = styled.div`
  display: none;
  background: linear-gradient(to bottom, #0040A1 60%, #007CDF);
  position: sticky;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 100vw;
  justify-content: space-around;
  align-items: center;
  padding: 5px 0;
  box-sizing: border-box;
  cursor-pointer;

  @media (max-width: 48em) {
    display: flex;
  }
`;

const AppBannerLogo = styled.img`
  width: 55px;
  margin-top: -15px;
`;

const AppBannerText = styled(PrimaryText)`
  color: ${colors.anakiwaLight};
  font-size: 13px;
  text-align: center;
  max-width: 150px;
`;

const AppBannerButton = styled.button`
  color: ${colors.white};
  background: ${colors.amaranth};
  border: none;
  border-radius: 4px;
  font-size: 12px;
  padding: 6px 8px;
  font-family: Avenir-Medium;
`;

export default AppBanner;
